import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";

const Retail = ({ onChange, propertyDataBackend }) => {
  const [propertyData, setPropertyData] = useState({
    total_quantity: "",
    rental_yield_percentage: "",
  });

  useEffect(() => {
    if (propertyDataBackend) {
      setPropertyData({
        total_quantity: propertyDataBackend.total_quantity || "",
        rental_yield_percentage:
          propertyDataBackend.rental_yield_percentage || "",
      });
    }
  }, [propertyDataBackend]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...propertyData, [name]: value };
    setPropertyData(updatedState);
    if (onChange) {
      onChange(updatedState);
    }
  };

  return (
    <div className="grid-span-2">
      <div className="grid-template-2 gap-10">
        <TextInput
          label="No. of Units"
          min={0}
          required
          type="number"
          value={propertyData.total_quantity || "N/A"}
          name="total_quantity"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Rental Yield(%)"
          min={0}
          required
          type="number"
          value={propertyData.rental_yield_percentage || "N/A"}
          name="rental_yield_percentage"
          onChange={handleAddChange}
        ></TextInput>
      </div>
    </div>
  );
};

export default Retail;
